import React, { useEffect } from 'react';
import Header from './Header';
import AboutSection from './AboutSection';
import useDarkMode from '../hooks/useDarkMode';
import useLanguage from '../hooks/useLanguage';
import translations from '../i18n';

export default function AboutPage() {
  const [darkMode] = useDarkMode();
  const [language] = useLanguage();
  const t = translations[language];

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className={darkMode ? 'app dark' : 'app light'}>
      <Header />
      <main>
        <AboutSection darkMode={darkMode} language={language} t={t} />
      </main>
    </div>
  );
}
